import { render, staticRenderFns } from "./currentsAccounts.vue?vue&type=template&id=a3201f02&scoped=true&"
import script from "./currentsAccounts.vue?vue&type=script&lang=js&"
export * from "./currentsAccounts.vue?vue&type=script&lang=js&"
import style0 from "./currentsAccounts.vue?vue&type=style&index=0&id=a3201f02&prod&lang=css&"
import style1 from "./currentsAccounts.vue?vue&type=style&index=1&id=a3201f02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3201f02",
  null
  
)

export default component.exports